export const NO_VALUE_SYMBOL = '–';
